module.exports = __webpack_public_path__ + "src/images/begin-step-3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/begin-step-3.jpg
// module id = 1138
// module chunks = 0